import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import queryString from 'query-string';

import BaseAlert from 'components/wrappers/BaseAlert';
import { isAuthenticatedSelector } from 'redux/selectors/authenticationSelectors';
import { confirmAccount } from 'redux/reducers/authenticationSlice';
import { ApplicationTypeEnum } from 'api/accountApiClient';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';

export default function ConfirmationPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useAppSelector(isAuthenticatedSelector);
  const { uid: uId, c: code } = queryString.parse(location.search);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function confirmSignUp() {
      setIsLoading(true);
      const result = await dispatch(
        confirmAccount({
          uId,
          code,
          applicationType: ApplicationTypeEnum.Backoffice,
        }),
      );

      setIsLoading(false);

      const redirectPath = isAuthenticated ? '/' : '/login';
      const successMessage = isAuthenticated
        ? 'Thank you for confirmation.'
        : 'Thank you for confirmation. Please log in to continue.';

      navigate(redirectPath, { replace: true });

      if (confirmAccount.fulfilled.match(result)) {
        BaseAlert.success(successMessage);
      }
    }

    confirmSignUp();
  }, [dispatch, uId, code, navigate, isAuthenticated]);

  return <div>{isLoading && <Spin size="large" />}</div>;
}
